import React, { useState } from "react";
import {
  FaTimesCircle,
  FaCheckCircle,
  FaPlayCircle,
  FaBus,
  FaUserClock,
  FaShieldAlt,
  FaUsersSlash,
  FaClock,
  FaIdCard,
  FaBell,
  FaSnowflake,
  FaVideo,
} from "react-icons/fa";
import commutingVideo from "../Assets/videos/Staffline_Video.mp4";
import "./OurStorySection.css";

const OurStorySection = () => {
  const [showVideo, setShowVideo] = useState(false);

  /* ===== PROBLEMS ===== */
  const problems = [
    {
      icon: <FaClock />,
      title: "Long Waiting Times",
      desc: "Workers spend 1–2 hours daily waiting for unreliable transport.",
    },
    {
      icon: <FaUsersSlash />,
      title: "Overcrowding",
      desc: "Passengers are packed beyond safe capacity on trotros and buses.",
    },
    {
      icon: <FaShieldAlt />,
      title: "Safety Concerns",
      desc: "Risk of accidents, theft, and harassment during daily commutes.",
    },
    {
      icon: <FaUserClock />,
      title: "Lateness & Fatigue",
      desc: "Unreliable transport leads to stress, lateness, and reduced productivity.",
    },
  ];

  /* ===== SOLUTIONS ===== */
  const solutions = [
    {
      icon: <FaBus />,
      title: "Fixed Scheduled Rides",
      desc: "Buses depart on time, every working day, on designated routes.",
    },
    {
      icon: <FaIdCard />,
      title: "Assigned Seats",
      desc: "Every subscriber has a guaranteed seat, bus, and pickup point.",
    },
    {
      icon: <FaSnowflake />,
      title: "Comfort & Safety",
      desc: "AC buses with CCTV monitoring and vetted professional drivers.",
    },
    {
      icon: <FaBell />,
      title: "SMS Notifications",
      desc: "Real-time updates on schedules, delays, and route changes.",
    },
  ];

  return (
    <section className="staffline-about-story">
      <div className="container">

        {/* ===== SECTION HEADER ===== */}
        <div className="staffline-about-story-header">
          <span className="staffline-about-section-tag">Our Story</span>
          <h2 className="staffline-about-section-title">
            The Problem We're Solving
          </h2>
          <p className="staffline-about-section-desc">
            Every day, thousands of workers in Ghana face the same struggle:
            unreliable, uncomfortable, and unsafe transport. StaffLine was
            created to end this cycle.
          </p>
        </div>

        {/* ===== VIDEO BANNER (MOVED TO TOP) ===== */}
        <div className="staffline-about-video-banner">
          <div className="staffline-about-video-banner-inner">
            <FaVideo className="staffline-about-video-icon" />
            <h3>See the Daily Struggle for Yourself</h3>
            <p>
              Watch this short clip to understand the reality of commuting in
              Ghana — and why StaffLine exists.
            </p>

            {!showVideo ? (
              <button
                className="staffline-about-video-play"
                onClick={() => setShowVideo(true)}
              >
                <FaPlayCircle /> Play Video
              </button>
            ) : (
              <div className="staffline-about-video-wrapper">
                <video
                  src={commutingVideo}
                  controls
                  autoPlay
                  className="staffline-about-video-player"
                >
                  Your browser does not support the video tag.
                </video>
              </div>
            )}
          </div>
        </div>

        {/* ===== PROBLEM GRID ===== */}
        <div className="staffline-about-problem-grid">
          {problems.map((p, i) => (
            <div className="staffline-about-problem-card" key={i}>
              <div className="staffline-about-problem-icon">{p.icon}</div>
              <h3>{p.title}</h3>
              <p>{p.desc}</p>
              <span className="staffline-about-problem-x">
                <FaTimesCircle /> Problem
              </span>
            </div>
          ))}
        </div>

        {/* ===== SOLUTION GRID ===== */}
        <div className="staffline-about-solution-header">
          <span className="staffline-about-section-tag staffline-about-section-tag-orange">
            Our Solution
          </span>
          <h2 className="staffline-about-section-title">
            How StaffLine Changes Everything
          </h2>
          <p className="staffline-about-section-desc">
            A subscription-based shuttle service built around reliability,
            comfort, and safety — so you can focus on your work, not your
            commute.
          </p>
        </div>

        <div className="staffline-about-solution-grid">
          {solutions.map((s, i) => (
            <div className="staffline-about-solution-card" key={i}>
              <div className="staffline-about-solution-icon">{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
              <span className="staffline-about-solution-check">
                <FaCheckCircle /> Solution
              </span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default OurStorySection;